
const detail = {
  path: 'detail/:id',
  component: resolve => require(['../../../../../pages/modules/cloudMarket/detail'], resolve),
}

export default detail
